import { getNode, getPod, listNodes, listPods } from "@/apis/monitoring";

export const RESOURCE_TYPE_MONTORING = "monitoring";

export const MonitoringDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    let response, data, total;
    if("node" === meta.action) {
      response = await listNodes({current: pagination.current, pageSize: pagination.pageSize , filters});
      data = response.nodes;
      total = data.length;
    } else {
      response = await listPods({current: pagination.current, pageSize: pagination.pageSize, filters});
      data = response.pods;
      total = response.listMeta.totalItems;
    }
    return {
        data,
        total: total,
    };
  },
  getOne: async ({ resource, id, meta }) => {
    let data;
    if("node" === meta.action)
      data = await getNode(id);
    else 
      data = await getPod(id, meta["namespace"]);
    return data.value;
  }
};